import React from 'react';
import PropTypes from 'prop-types';
import TextInput from '../TextInput';
import InputLabel from '../InputLabel';

function EditableTextInput({
    containerClassName,
    disableLabel,
    editing,
    inputProps,
    labelText,
    labelProps,
    text,
    help,
})
{
    return (
        editing ? (
            <div className={containerClassName}>
                { !disableLabel
                    && (
                        <label className={`tw-font-bold tw-mb-3 ${labelProps.className}`}>{labelText}</label>
                    )}
                <TextInput
                    className={inputProps.className}
                    readOnly={inputProps.readOnly}
                    onChange={inputProps.onChange}
                    placeholder={inputProps.placeholder}
                    path={inputProps.path}
                    type={inputProps.type}
                    value={inputProps.value}
                    icon={inputProps.icon}
                    errorClassName={inputProps.errorClassName}
                    error={inputProps.error}
                    printErrors={inputProps.printErrors}
                    disabled={inputProps.disabled}
                    iconMessage={inputProps.iconMessage}
                    onEnter={inputProps.onEnter}
                />
                {help && <span className="tw-text-primary-default tw-text-sm">{help}</span>}
            </div>
        ) : (
            <div className={`tw-flex tw-flex-row tw-py-1.5 tw-rounded tw-px-3 tw-border tw-bg-gray-50 dark:tw-bg-neutral-600 dark:tw-border-gray-400 hover:tw-border-primary-default ${containerClassName}`}>
                <InputLabel label={labelText} text={inputProps.type === 'password' ? '********' : text} />
            </div>
        )
    );
}

EditableTextInput.defaultProps = {
    containerClassName: '',
    disableLabel: false,
    labelProps: {
        className: 'tw-text-sm',
    },
    text: '',
};

EditableTextInput.propTypes = {
    containerClassName: PropTypes.string,
    disableLabel: PropTypes.bool,
    editing: PropTypes.bool.isRequired,
    inputProps: PropTypes.shape({
        className: PropTypes.string,
        readOnly: PropTypes.bool,
        onChange: PropTypes.func,
        placeholder: PropTypes.string,
        path: PropTypes.string,
        type: PropTypes.string,
        value: PropTypes.any,
        icon: PropTypes.any,
        errorClassName: PropTypes.string,
        error: PropTypes.node,
        printErrors: PropTypes.bool,
        disabled: PropTypes.bool,
        iconMessage: PropTypes.string,
        onEnter: PropTypes.func,
    }),
    labelText: PropTypes.string.isRequired,
    labelProps: PropTypes.shape({
        className: PropTypes.string.isRequired,
    }),
    text: PropTypes.node,
    help: PropTypes.string,
};

export default EditableTextInput;
